// extracted by mini-css-extract-plugin
module.exports = {"global":"Seccion_global__1lX8g","parte1":"Seccion_parte1__31Hfc","parte1h3":"Seccion_parte1h3__blpYu","parte2":"Seccion_parte2__1AqAX"};